/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */
import "rodal/lib/rodal.css";

import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { RootState } from "store/types";

import { Button, SimpleModal } from "UpduoLibrary";
import {
  skaleLightRed,
  skalePrimaryBlue,
  skaleWhite,
} from "config/UpduoColors";
import { logoutResetState } from "config/ResetState";
import * as UpduoAnalytics from "config/UpduoAnalytics";

interface LogoutModalProps {
  isVisible: boolean;
  onClose: () => void;
  history?: any; // TODO it seems like history is never used?
}

export default function LogoutModal({ isVisible, onClose }: LogoutModalProps) {
  const history = useHistory();

  const startObject = useSelector((state: RootState) => state.startObject);

  const _handleLogoutButtonPress = () => {
    UpduoAnalytics.logEvent("user-logout", {
      email: startObject.email,
    });
    logoutResetState();
    onClose();
    history.push("/start");
  };

  return (
    <SimpleModal
      isVisible={isVisible}
      onClose={onClose}
      heading={"Are you sure you want to\nlog out?"}
      headingStyle={{ marginBottom: 20 }}
      buttons={[
        <Button
          key={"log-out"}
          onPress={() => {
            _handleLogoutButtonPress();
          }}
          color={skaleWhite}
          height={60}
          width={330}
          borderColor={skaleLightRed}
          borderWidth={2}
          textColor={skaleLightRed}
          text={"Log Out"}
        />,
        <Button
          key={"cancel"}
          onPress={() => {
            onClose();
            UpduoAnalytics.logEvent("user-cancel-logout", {
              email: startObject.email,
            });
          }}
          fontSize={16}
          height={60}
          marginTop={20}
          color={skalePrimaryBlue}
          textColor={skaleWhite}
          width={330}
          text={"Cancel"}
        />,
      ]}
    />
  );
}
